import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    certificate_url: null,
  },
  getters: {
    certificate_url: ({certificate_url}) => certificate_url,
  },
  mutations: {
    SET_CERTIFICATE_URL(state, value) {
      state.certificate_url = value;
    },
  },
  actions: {
    async get_certificate({commit}, course_passing_id) {
      try {
        const certificate_url = await api.course.get_certificate(course_passing_id);
        await commit('SET_CERTIFICATE_URL', certificate_url.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
